import "core-js/modules/es.array.find";
import "core-js/modules/es.string.split";
import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(getMsaFromPath);

import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { call } from 'redux-saga/effects';
import { msas } from 'redux/saga/entities/bound';
import { getMsaAliasToId } from 'dynamic-data/msa-alias-to-id';
import { msaByAlias } from 'redux/saga/selectors/msas';
export function getMsaFromPath(client, path) {
  var msaAliases, msasList, parts, msaAlias;
  return regeneratorRuntime.wrap(function getMsaFromPath$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          msaAliases = getMsaAliasToId();
          _context.next = 3;
          return call(fetchEntityIfNeeded, msas, [client]);

        case 3:
          msasList = _context.sent;
          parts = (path || '').split('/');
          msaAlias = parts.find(function (part) {
            return part in msaAliases;
          });
          return _context.abrupt("return", msaByAlias(msasList, msaAlias));

        case 7:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}